import { defineComponent as _defineComponent } from 'vue'
import { toRefs } from '@nuxtjs/composition-api';
import type { DefineComponent } from 'vue';

interface Props {
    tag?: string | DefineComponent,
    canonical?: boolean;
    absolute?: boolean;
    withBase?: boolean;
    to?: string,
    href?: string,
    external?: boolean,
    target?: '_blank' | '_parent' | '_self' | '_top' | (string & {}) | null,
    rel?: 'noopener' | 'noreferrer' | 'nofollow' | 'sponsored' | 'ugc' | (string & {}) | null,
    noRel?: boolean,
    prefetchedClass?: string,
    prefetch?: boolean,
    theme?: 'light' | 'dark',
    disabled?: boolean,
    size?: 'l' | 'm' | 's' | 'xs',
    equallyPadded?: boolean,
}
export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  props: {
    tag: { default: 'NuxtLink' },
    canonical: { type: Boolean },
    absolute: { type: Boolean },
    withBase: { type: Boolean },
    to: null,
    href: null,
    external: { type: Boolean },
    target: null,
    rel: null,
    noRel: { type: Boolean },
    prefetchedClass: null,
    prefetch: { type: Boolean },
    theme: null,
    disabled: { type: Boolean },
    size: { default: 'm' },
    equallyPadded: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { tag: string | DefineComponent, canonical?: boolean, absolute?: boolean, withBase?: boolean, to?: string, href?: string, external?: boolean, target?: '_blank' | '_parent' | '_self' | '_top' | (string & {}) | null, rel?: 'noopener' | 'noreferrer' | 'nofollow' | 'sponsored' | 'ugc' | (string & {}) | null, noRel?: boolean, prefetchedClass?: string, prefetch?: boolean, theme?: 'light' | 'dark', disabled?: boolean, size: 'l' | 'm' | 's' | 'xs', equallyPadded?: boolean };

;



const {
    theme,
    size,
    tag,
    disabled,
} = toRefs(props);

return { __sfc: true,props, theme, size, tag, disabled }
}

})